import { create } from "zustand"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { getUsageRawAPI } from "@/apis/usage-api"
import { RESOURCE_META } from "@/constants/resource-const"
import { calcStartDate } from "@/utils/calc-start-date-util"

export const usageChartStore = create((set, get) => ({
  requestId: 0,
  allUnitUsages: [],
  groupStats: [],
  summary: null,
  setUsages: (allUnitUsages, groupStats, summary) => set({ allUnitUsages, groupStats, summary }),

  startIndex: 0,
  endIndex: 0,
  startLabel: "-",
  endLabel: "-",

  usageSum: 0,
  leakSum: 0,
  leakRate: 0,

  pickUnit: null,
  setPickUnit: (pickUnit) => set({ pickUnit }),

  selectedPeriod: "months",
  setSelectedPeriod: (selectedPeriod) => set({ selectedPeriod }),

  unit: "m³",

  setRange: (start, end, labels) =>
    set({
      startIndex: start,
      endIndex: end,
      startLabel: labels?.[start] ?? "-",
      endLabel: labels?.[end - 1] ?? "-"
    }),

  setSummary: ({ usage, leak }) =>
    set({
      usageSum: usage,
      leakSum: leak,
      leakRate: usage > 0 ? (leak / usage) * 100 : 0
    }),

  // INFO: 고객 정보(키)
  userNo: "",

  series: [],
  xLabels: [],
  rawXLabels: [],

  setUsageChart: (usageData, leakData, xLabels) => {
    const usageSeries = {
      color: RESOURCE_META["water"].colors.primary,
      data: usageData,
      name: "usage"
    }
    const leakSeries = {
      color: RESOURCE_META["water"]["leak"].colors.primary,
      data: leakData,
      name: "leakAmount"
    }
    const filtered = xLabels.map((l) => {
      return l.slice(5).replace("-", ".")
    })
    set({ series: [usageSeries, leakSeries], xLabels: filtered, rawXLabels: xLabels })
  },

  setChart: (usageData, resource, xLabels) => {
    const usageSeries = {
      color: RESOURCE_META[resource].colors.primary,
      data: usageData,
      name: "usage"
    }
    const filtered = xLabels.map((l) => {
      return l.slice(5).replace("-", ".")
    })
    set({ series: [usageSeries], xLabels: filtered, rawXLabels: xLabels })
  },

  apiGetUsage: async ({ dong, ho, startDate, endDate, resource = "water", preset } = {}) => {
    const { setUsageChart, setChart, setSummary, setRange } = get()
    const { sido, kapt_code, ended_at } = aptSearchStore.getState().pickApt
    const end_date = endDate ?? ended_at
    const start_date =
      startDate ?? calcStartDate(end_date, preset ?? get().selectedPeriod ?? "months")
    const nextRequestId = get().requestId + 1
    set({ requestId: nextRequestId })

    const { x_labels, datasets, unit } = await getUsageRawAPI({
      sido,
      kapt_code,
      dong,
      ho,
      start_date,
      end_date,
      resource
    })

    if (get().requestId !== nextRequestId) return

    resource === "water"
      ? setUsageChart(datasets.usages, datasets.leaks, x_labels)
      : setChart(datasets.usages, resource, x_labels)

    const usage = datasets.usages.reduce((a, b) => a + b, 0)

    let leak = 0
    if (resource === "water") {
      leak = datasets.leaks.reduce((a, b) => a + b, 0)
    }

    setSummary({ usage, leak })
    if (x_labels?.length) {
      setRange(0, x_labels.length, x_labels)
    }
    set({ unit })
  },

  reset: () =>
    set({
      requestId: 0,
      allUnitUsages: [],
      groupStats: [],
      summary: null,
      startIndex: 0,
      endIndex: 0,
      startLabel: "-",
      endLabel: "-",
      usageSum: 0,
      leakSum: 0,
      leakRate: 0,
      unit: "m³",
      userNo: "",
      series: [],
      xLabels: [],
      rawXLabels: []
    })
}))
